import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { DwFormContextMode } from '@devwareapps/devware-cap';
import { AppMetaDataItemNames, CourseEntity } from '../../../../meta-data/app-meta-data.service';

@Component({
  selector: 'app-course-cap-form-host',
  templateUrl: './course-cap-form-host.component.html',
  styleUrls: ['./course-cap-form-host.component.scss']
})
export class CourseCapFormHostComponent implements OnChanges {
  @Input() courseId: number;
  @Input() studentCourseId?: number | null;
  @Input() configKeyPart = 'student-endorsements';

  item = AppMetaDataItemNames.Course;
  formMode = DwFormContextMode.edit;
  formData: Partial<CourseEntity> | null = null;

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes.courseId && !changes.studentCourseId) {
      return;
    }

    if (!this.courseId) {
      this.formData = null;
      return;
    }

    // Provide the parent Course identity up front so CAP context builders have
    // a stable Course object even before the metadata form finishes loading.
    this.formData = {
      _itemName: AppMetaDataItemNames.Course,
      CourseId: this.courseId
    };
  }
}
